export default "__VITE_ASSET__DKrwxULc__"